import { jsx as _jsx } from "react/jsx-runtime";
import { CenterContainer } from "../../subcomponents";
var ErrorComponent = function () { return (_jsx(CenterContainer, { children: _jsx("h1", { children: "There was a problem" }) })); };
export default ErrorComponent;
